import { Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class SettingsValuesService {


  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  // Inactivity Timeout in seconds
  public get $inactivityTimeout() {
    return this._SettingsService.$inactivityTimeout;
  }

  public get FootPrintAPI() {
    return this._SettingsService['FootPrintAPI'];
  }
  public get MongoDB() {
    return this._SettingsService['MongoDB'];
  }

  public app: SettingsValuesService = this;

  public get Utilities() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get MovuRobotics() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get SalesOrders() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get FootprintTestUtilities() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Cartonization() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
}
